import { DESCRIPTION_FIELD } from '@/constants/calendar';
import axios from 'axios';

const getPresignedUrl = async (filePath: string) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/google-calendar/presigned-urls`,
    {
      key: filePath,
    },
    {
      withCredentials: true,
    }
  );

  return response.data.data.preSignedUrl;
};

const uploadFileToS3 = async (file: File, url: string) => {
  const response = await axios.put(url, file, {
    headers: {
      'Content-Type': file.type,
    },
  });

  return response;
};

const makeDescriptionJSon = (data, speakers) => {
  const descriptionString = DESCRIPTION_FIELD.map(field => {
    if (field === DESCRIPTION_FIELD[6]) {
      return `${field}: ${speakers.map(speaker => `${speaker}`).join(', ')}`;
    }
    return `${field}: ${data[field]}`;
  }).join('\n');

  const jsonString = `${descriptionString}`;
  return jsonString;
};

const makeEventForm = (data, timezone, speakers) => {
  const jsonString = makeDescriptionJSon(data, speakers);

  const endDate = new Date(data.end);
  endDate.setDate(endDate.getDate() + 1);

  const event = {
    summary: data.summary,
    location: data.location,
    description: jsonString,
    start: !data.duration
      ? {
          dateTime: `${data.start}:00`,
          timeZone: timezone,
        }
      : {
          date: data.start,
        },
    end: !data.duration
      ? {
          dateTime: `${data.end}:00`,
          timeZone: timezone,
        }
      : {
          date: endDate.toISOString().split('T')[0],
        },
  };
  return event;
};

const makeFileName = (key: string, origin: string) => {
  const extension = origin.split('.').pop();

  return `${key}.${extension}`;
};

const uploadFile = async (key: string, file: File) => {
  const uploadUrl = await getPresignedUrl(key);
  const response = await uploadFileToS3(file, uploadUrl);
  return response;
};

export {
  uploadFile,
  makeFileName,
  makeEventForm,
  uploadFileToS3,
  getPresignedUrl,
};
